import { render, staticRenderFns } from "./pedidos_cancelamento.vue?vue&type=template&id=bf81c578&"
import script from "./pedidos_cancelamento.vue?vue&type=script&lang=js&"
export * from "./pedidos_cancelamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports